export default "__VITE_ASSET__4u4_v6w0__"